import { Exclude, Type } from 'class-transformer';

export class ConveyanceCommunitySoaRequestResultDto {
    soaRequestId: number;
    confirmationNumber: string;
    documentRequest: string;
    buyerName: string;

    @Type(() => Date)
    requestedOn: Date;

    requestingCompany: string;
    attachmentsCount: number;

    // Transient variable
    @Exclude()
    communityId: number;
}
